import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import SelectDropdown from './SelectDropdown';

function formatMoney(number) {
  var n = number,
  c = 0,
  d = ".",
  t = ",",
  s = n < 0 ? "-" : "",
  r = Math.round(n),
  i = String(parseInt(r = Math.abs(Number(r) || 0).toFixed(c), 10)),
  size = i.length,
  j = size > 3 ? size % 3 : 0;

  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(r - i).toFixed(c).slice(2) : "");
}

const TableRow = ({label, display}) => (
  <tr>
    <th>{ label }</th>
    <td>{ display }</td>
  </tr>
);

export default class DepartamentoModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
      deptId: '',
      desarrollo: '',
      error: null,
      showing: false,
      isLoaded: false,
      details: {},
      showPrice: false,
      discount: 0,
      originalHeight: 0,
    };
  }

  calculateDiscount = () => (discount) => {
    this.setState({
      discount: discount,
      showPrice: true
    });
  }
  
  openModal(deptId, desarrollo, originalHeight) {
    let apiEndpoint = '/search/departamento/' + deptId;

    this.setState({
      deptId,
      desarrollo,
      showing: true,
      originalHeight: originalHeight,
    });

    const message = {
      desarrollo,
      frameHeight: 655
    };

    fetch(apiEndpoint)
      .then(res => res.json())
      .then(
        (result) => {
          const descuentos = result.descuentos;
          const newState = {
            isLoaded: true,
            details: result
          };
          let defaultSelected = 0;
          if (descuentos && descuentos.length) {
            descuentos.map((descuento, idx) => {
              if (descuento.label === '35%') {
                defaultSelected = idx;
              }
              return true;
            });

            const descuento = descuentos[defaultSelected].value;
            newState['discount'] = descuento;
            newState['showPrice'] = true;
          }
          this.setState(newState);
          setTimeout(() => {
            // eslint-disable-next-line no-restricted-globals
            parent.postMessage(message, '*');
          }, 10);
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error
          });
        }
      );
  }

	onCloseModal = () => {
    const { desarrollo, originalHeight } = this.state;
    const message = {
      desarrollo,
      frameHeight: originalHeight
    };

    this.setState({ showing: false, showPrice: false });
    setTimeout(() => {
      // eslint-disable-next-line no-restricted-globals
      parent.postMessage(message, '*');
    }, 10);
  }

  onPrintCotizacion = () => () => {
    const { deptId, discount, desarrollo } = this.state;
    const webRootUrl = process.env.REACT_APP_WEB_ROOT_URL;
    const pdfUrl = `${webRootUrl}/imprime/${ desarrollo }/${ deptId }/${ discount }`;
    window.open(pdfUrl);
  }

  renderModalContent() {
    let propiedad = this.state.details;
    let precioFinal = '';
    let descuento = '';
    let precioPropiedad = parseFloat(propiedad.precio_venta);
    let precioLista = '$' + formatMoney(precioPropiedad);

    if (this.state.showPrice) {
      let discount = parseFloat(this.state.discount);
      let precioDescuento = precioPropiedad * discount;
      let precioConDescuento = precioPropiedad - precioDescuento;

      descuento = (discount * 100).toFixed(2) + '%';
      precioFinal = '$' + formatMoney(precioConDescuento);
    }

    const planoLink = <a href={ propiedad.plano } target="_blank">Ver Plano</a>;
    const dropDown = <SelectDropdown name="enganche" selected={ this.state.discount } options={ propiedad.descuentos } onChange={ this.calculateDiscount() } />;

    return (
      <div className="modalContents">
        <table>
          <tbody>
            <TableRow label="Nivel" display={ propiedad.nivel } />
            <TableRow label="Departamento" display={ propiedad.departamento } />
            { propiedad.nivel !== '0 m2' && <TableRow label="Interior" display={ propiedad.interior } /> }
            { propiedad.doble_altura !== '0 m2' && <TableRow label="Doble Altura" display={ propiedad.doble_altura } /> }
            { propiedad.terraza !== '0 m2' && <TableRow label="Terraza" display={ propiedad.terraza } /> }
            { propiedad.roof_garden !== '0 m2' && <TableRow label="Roof Garden" display={ propiedad.roof_garden } /> }
            { propiedad.jardin !== '0 m2' && <TableRow label="Jardín" display={ propiedad.jardin } /> }
            { propiedad.estacionamiento !== '0 m2' && <TableRow label="Estacionamiento" display={ propiedad.estacionamiento } /> }
            { propiedad.bodega !== '0 m2' && <TableRow label="Bodega" display={ propiedad.bodega } /> }
            { propiedad.total !== '0 m2' && <TableRow label="Total de Propiedad" display={ propiedad.total } /> }
            <TableRow label="Distribución" display={ planoLink } />
            <tr>
              <td colSpan="2" className="spacer"></td>
            </tr>
            <TableRow label="Precio de Lista" display={ precioLista } />
            <TableRow label="Enganche" display={ dropDown } />
            <TableRow label="Descuento" display={ descuento } />
            <TableRow label="Precio Final" display={ precioFinal } />
            {this.state.showPrice && (
              <tr>
                <td colSpan="2">
                  <button className="btnImpCotiz" onClick={this.onPrintCotizacion()}>Imprimir Cotización</button></td>
              </tr>
            )}
            <tr>
              <td colSpan="2"><span className="nota_precio">PRECIOS Y DESCUENTOS SUJETOS A CAMBIOS SIN PREVIO AVISO.</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

	render() {
    let modalContent;
    if (this.state.error) {
      modalContent = <div className="modalContents">Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      modalContent = <div className="modalContents">Cargando...</div>;
    } else {
      modalContent = this.renderModalContent();
    }
    return (
			<Modal open={ this.state.showing } onClose={ this.onCloseModal } center>
					{ modalContent }
			</Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./react_src/Components/DepartamentoModal.js